import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../../services/apiAxios';
import helpers from '../../../mixins/helpers';
import moment from 'moment';
import axios from 'axios';

let requestRentabilidadNetaSemestral = axios.CancelToken.source();
let requestRentabilidadNetaAnual = axios.CancelToken.source();
let requestRentabilidadNetaSemestralTotal = axios.CancelToken.source();
let requestRentabilidadNetaAnualTotal = axios.CancelToken.source();

const state = {
    indicadorRentabilidadNetaAnual: {},
    indicadorRentabilidadNetaSemestral: {},
    /* Total -> incluye reembolsos */
    indicadorRentabilidadNetaAnualTotal: {},
    indicadorRentabilidadNetaSemestralTotal: {},

    indicadoresRentabilidadNetaAnualHistorico: [],
    indicadoresRentabilidadNetaSemestralHistorico: [],
    indicadoresRentabilidadNetaAnualTotalHistorico: [],
    indicadoresRentabilidadNetaSemestralTotalHistorico: [],

    resultadosIndicadorRentabilidadNeta: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADORES' (state) {
        state.indicadorRentabilidadNetaAnual = {};
        state.indicadorRentabilidadNetaSemestral = {};
        state.indicadorRentabilidadNetaAnualTotal = {};
        state.indicadorRentabilidadNetaSemestralTotal = {};
    },
    'INICIALIZAR_INDICADORES_HISTORICO' (state) {
        state.indicadoresRentabilidadNetaAnualHistorico = [];
        state.indicadoresRentabilidadNetaSemestralHistorico = [];
        state.indicadoresRentabilidadNetaAnualTotalHistorico = [];
        state.indicadoresRentabilidadNetaSemestralTotalHistorico = [];
    
    },

    'SET_INDICADOR_RENTABILIDAD_NETA_ANUAL'(state, indicador) {
        state.indicadorRentabilidadNetaAnual = indicador;
    },
    'SET_INDICADOR_RENTABILIDAD_NETA_SEMESTRAL'(state, indicador) {
        state.indicadorRentabilidadNetaSemestral = indicador;
    },
    'SET_INDICADOR_RENTABILIDAD_NETA_ANUAL_TOTAL'(state, indicador) {
        state.indicadorRentabilidadNetaAnualTotal = indicador;
    },
    'SET_INDICADOR_RENTABILIDAD_NETA_SEMESTRAL_TOTAL'(state, indicador) {
        state.indicadorRentabilidadNetaSemestralTotal = indicador;
    },

    'SET_INDICADORES_RENTABILIDAD_NETA_ANUAL_HISTORICO'(state, indicadores) {
        state.indicadoresRentabilidadNetaAnualHistorico = indicadores;
    },
    'SET_INDICADORES_RENTABILIDAD_NETA_SEMESTRAL_HISTORICO'(state, indicadores) {
        state.indicadoresRentabilidadNetaSemestralHistorico = indicadores;
    },
    'SET_INDICADORES_RENTABILIDAD_NETA_ANUAL_TOTAL_HISTORICO'(state, indicadores) {
        state.indicadoresRentabilidadNetaAnualTotalHistorico = indicadores;
    },
    'SET_INDICADORES_RENTABILIDAD_NETA_SEMESTRAL_TOTAL_HISTORICO'(state, indicadores) {
        state.indicadoresRentabilidadNetaSemestralTotalHistorico = indicadores;
    },


    'INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA'(state) {
        state.resultadosIndicadorRentabilidadNeta = [];
    },
    'SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA'(state, resultadosIndicadorRentabilidadNeta) {
        state.resultadosIndicadorRentabilidadNeta = resultadosIndicadorRentabilidadNeta;
    },
};

const getters = {
    getField,

    indicadorRentabilidadNetaAnual(state) {
        return state.indicadorRentabilidadNetaAnual;
    },
    indicadorRentabilidadNetaSemestral(state) {
        return state.indicadorRentabilidadNetaSemestral;
    },
    indicadorRentabilidadNetaAnualTotal(state) {
        return state.indicadorRentabilidadNetaAnualTotal;
    },
    indicadorRentabilidadNetaSemestralTotal(state) {
        return state.indicadorRentabilidadNetaSemestralTotal;
    },

    indicadoresRentabilidadNetaAnualHistorico(state) {
        return state.indicadoresRentabilidadNetaAnualHistorico;
    },
    indicadoresRentabilidadNetaSemestralHistorico(state) {
        return state.indicadoresRentabilidadNetaSemestralHistorico;
    },
    indicadoresRentabilidadNetaAnualTotalHistorico(state) {
        return state.indicadoresRentabilidadNetaAnualTotalHistorico;
    },
    indicadoresRentabilidadNetaSemestralTotalHistorico(state) {
        return state.indicadoresRentabilidadNetaSemestralTotalHistorico;
    },

    resultadosIndicadorRentabilidadNeta(state) {
        return state.resultadosIndicadorRentabilidadNeta;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES');
            resolve();
        })
    },
    getIndicadorRentabilidadNetaAnual ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-anual', { cancelToken: requestRentabilidadNetaAnual.token })
                .then(res => {
                    commit('SET_INDICADOR_RENTABILIDAD_NETA_ANUAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorRentabilidadNetaAnual() {
        requestRentabilidadNetaAnual.cancel();
        requestRentabilidadNetaAnual = axios.CancelToken.source();
    },
    getIndicadorRentabilidadNetaSemestral ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-semestral', { cancelToken: requestRentabilidadNetaSemestral.token })
                .then(res => {
                    commit('SET_INDICADOR_RENTABILIDAD_NETA_SEMESTRAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorRentabilidadNetaSemestral() {
        requestRentabilidadNetaSemestral.cancel();
        requestRentabilidadNetaSemestral = axios.CancelToken.source();
    },
    getIndicadorRentabilidadNetaAnualTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-anual/total', { cancelToken: requestRentabilidadNetaAnualTotal.token })
                .then(res => {
                    commit('SET_INDICADOR_RENTABILIDAD_NETA_ANUAL_TOTAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorRentabilidadNetaAnualTotal() {
        requestRentabilidadNetaAnualTotal.cancel();
        requestRentabilidadNetaAnualTotal = axios.CancelToken.source();
    },
    getIndicadorRentabilidadNetaSemestralTotal ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-semestral/total', { cancelToken: requestRentabilidadNetaSemestralTotal.token })
                .then(res => {
                    commit('SET_INDICADOR_RENTABILIDAD_NETA_SEMESTRAL_TOTAL', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    cancelarIndicadorRentabilidadNetaSemestralTotal() {
        requestRentabilidadNetaSemestralTotal.cancel();
        requestRentabilidadNetaSemestralTotal = axios.CancelToken.source();
    },

    inicializarHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADORES_HISTORICO');
            resolve();
        })
    },
    getIndicadoresRentabilidadNetaAnualHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-anual/historico')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_NETA_ANUAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresRentabilidadNetaSemestralHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-semestral/historico')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_NETA_SEMESTRAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresRentabilidadNetaAnualTotalHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-anual/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_NETA_ANUAL_TOTAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadoresRentabilidadNetaSemestralTotalHistorico ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get('indicadores/rentabilidad-neta-semestral/historico/total')
                .then(res => {
                    commit('SET_INDICADORES_RENTABILIDAD_NETA_SEMESTRAL_TOTAL_HISTORICO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getVentasIndicadorRentabilidadNeta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/ventas';
            if (params.semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/ventas';
            }
            if (params.totalNegocio) {
                url += '/total';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getVentasIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            let url = 'indicadores/rentabilidad-neta/historico/ventas';
            if (params.totalNegocio) {
                url += '/total';
            }
    
            apiAxios.get(url + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getComprasIndicadorRentabilidadNeta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/compras';
            if (params.semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/compras';
            }
            if (params.totalNegocio) {
                url += '/total';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getGastosIndicadorRentabilidadNeta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/gastos';
            if (params.semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/gastos';
            }
            if (params.totalNegocio) {
                url += '/total';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getComprasReembolsosIndicadorRentabilidadNeta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/compras-reembolsos';
            if (params.semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/compras-reembolsos';
            }
            if (params.totalNegocio) {
                url += '/total';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getGastosHonorariosIndicadorRentabilidadNeta ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/gastos-honorarios';
            if (params.semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/gastos-honorarios';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getComprasIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            let url = 'indicadores/rentabilidad-neta/historico/compras';
            if (params.totalNegocio) {
                url += '/total';
            }
    
            apiAxios.get(url + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getGastosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            let url = 'indicadores/rentabilidad-neta/historico/gastos';
            if (params.totalNegocio) {
                url += '/total';
            }
    
            apiAxios.get(url + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getComprasReembolsosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/compras-reembolsos/total' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getInversionesBancariasIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/inversiones-bancos';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/inversiones-bancos';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getInversionesBancosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/inversiones-bancos' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getGastosBancariosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/bancos';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/bancos';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getGastosBancariosPlanesPagosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/gastos-bancos-planes';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/gastos-bancos-planes';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getGastosBancariosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/bancos' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getSueldosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/sueldos';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/sueldos';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getSueldosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/sueldos' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getImpuestosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/impuestos';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/impuestos';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getImpuestosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/impuestos' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getImpuestosBancosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/impuestos-bancos';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/impuestos-bancos';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getImpuestosBancosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/impuestos-bancos' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getInteresesPlanesPagosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/impuestos-planes-bancos';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/impuestos-planes-bancos';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getInteresesPlanesPagosPagosExternosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/impuestos-planes-pagos';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/impuestos-planes-pagos';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getInteresesPlanesPagosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/impuestos-planes-bancos' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getTransferenciasPremiosIndicadorRentabilidadNeta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/transferencias-premios';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/transferencias-premios';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getTransferenciasPremiosIndicadorRentabilidadNetaHistorico ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/transferencias-premios' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDeudaComercial ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/deuda-comercial';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/deuda-comercial';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDeudaComercialHistorica ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/deuda-comercial' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getVentasDeudaComercial ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/deuda-comercial/ventas';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/deuda-comercial/ventas';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getVentasDeudaComercialHistorica ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/deuda-comercial/ventas' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getVentasDiferenciasCambio ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/diferencia-cambio/ventas';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/diferencia-cambio/ventas';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getVentasDiferenciasCambioHistorica ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/diferencia-cambio/ventas' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getComprasDiferenciasCambio ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let url = 'indicadores/rentabilidad-neta-anual/diferencia-cambio/compras';
            if (semestral) {
                url = 'indicadores/rentabilidad-neta-semestral/diferencia-cambio/compras';
            }

            apiAxios.get(url)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getComprasDiferenciasCambioHistorica ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS_INDICADOR_RENTABILIDAD_NETA');

            let query = '?fechaDesde=' + moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta=' + moment(params.fechaHasta).format('YYYY-MM-DD');

            apiAxios.get('indicadores/rentabilidad-neta/historico/diferencia-cambio/compras' + query)
                .then(res => {
                    commit('SET_RESULTADOS_INDICADOR_RENTABILIDAD_NETA', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}